<!-- 环境监测 -->
<style lang="scss" scoped>
.hiddenDiv {
  display: none !important;
}
.left_kanban {
  position: absolute;
  left: 107px;
  top: 135px;
  pointer-events: all;
  width: 417px;
  .outer {
    margin-top: 20px;
  }
}
.waterPannelThree {
  position: absolute;
  pointer-events: all;
  z-index: 1000 !important;
}
.icon1 {
  position: absolute;
  left: 1039px;
  top: 224px;
  img {
    width: 46px;
    height: 64.03px;
  }
}

.right_kanban {
  position: absolute;
  right: 43px;
  top: 135px;
  width: 416px;
  .water {
    width: 100%;
    height: 297px;
  }
  .air {
    margin-top: 20px;
    width: 100%;
  }
}

.icon2 {
  position: absolute;
  left: 803px;
  top: 751px;

  img {
    width: 56px;
    height: 68px;
  }
}

.warning {
  position: absolute;
  left: 617px;
  top: 844px;

  img {
    width: 777px;
    height: 136px;
  }
}
.returnScence {
  pointer-events: all;
  position: absolute;
  width: 144px;
  height: 56px;
  left: 536px;
  top: 135px;
  cursor: pointer;
  background-image: url("../../../../assets/pagesImg/returnBtn-normal.png");

  &:hover {
    background-image: url("../../../../assets/pagesImg/returnBtn-active.png");
  }
}
.bot-data {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .data-item {
    display: flex;
    align-items: center;
    justify-content: space-around;
    .item-key {
      white-space: nowrap;
    }
  }
}
.detail {
  display: grid;
  grid-template-columns: 160px 160px;
  // grid-template-rows: repeat(5, 29px);
  gap: 4px 20px;
  overflow: hidden;
  .contentList {
    padding: 4px 10px;
    display: flex;
    justify-content: space-between;
    width: 160px;
    font-size: 14px;
    color: rgba(239, 239, 239, 0.7);
    background: linear-gradient(
      270deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.2) 100%
    );
    .text {
      width: 60px;
      white-space: nowrap;
    }
    .value {
      font-size: 14px;
      line-height: 20.72px;
    }
    .normalData-color {
      color: #fff;
    }
    .alarm-color {
      color: #f1802f;
    }
  }
}
.time-type-select {
  margin-top: 20px;
  display: flex;
  align-items: center;
  .time-type-item {
    margin-right: 7px;
    width: 40px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .time-type-item:last-child {
    margin-right: 0;
  }
  #active {
    background: rgba(175, 175, 175, 0.2);
  }
}
.bot-content {
  margin-top: 15px;
  width: 341px;
  height: 140px;
}
</style>
<template>
  <div
    @pointerdown="
      (e) => {
        e.preventDefault();
      }
    "
    @pointerup="
      (e) => {
        e.preventDefault();
      }
    "
  >
    <div class="returnScence" @click="returnScence"></div>
    <div class="left_kanban common-bg" v-show="isShowUI">
      <div class="air-in">
        <air-qual-in :airArrayIn="airArrayIn"></air-qual-in>
      </div>

      <div class="outer">
        <air-qual :airArray="airArray" :airArrayBot="airArrayBot"> </air-qual>
      </div>

      <!-- <img src="@/assets/cut/env_left.png" alt="" /> -->
    </div>
    <!-- <div class="icon1">
      <img src="@/assets/cut/env_icon1.png" alt="">
    </div> -->

    <pannel-box
      class="waterPannelThree"
      ref="waterPannel"
      headerName="环境监测"
      @close="closeDialog"
      @pointerdown.native="uiClick"
      :headerData="headerData"
      :class="!isShowDialog ? 'hiddenDiv' : ''"
    >
      <div class="detail" v-if="showbotDetail">
        <div
          class="contentList"
          v-for="(item, key, index) in botData"
          :key="index"
        >
          <div class="text" @click="chooseData(key)">
            {{ showbotData(key) }}
          </div>
          <div
            class="value"
            :class="item.alarm == '0' ? 'normalData-color' : 'alarm-color'"
          >
            {{ showItem(item.value)
            }}<span class="detail-unit-data">{{ showUnit(item.value) }}</span>
          </div>
        </div>
      </div>
      <div class="time-type-select" v-if="showHistory">
        <div
          class="time-type-item"
          :id="timeValue == 'day' ? 'active' : ''"
          @click="changeDay('day')"
        >
          时
        </div>
        <div
          class="time-type-item"
          :id="timeValue == 'month' ? 'active' : ''"
          @click="changeDay('month')"
        >
          日
        </div>
        <div
          class="time-type-item"
          :id="timeValue == 'year' ? 'active' : ''"
          @click="changeDay('year')"
        >
          月
        </div>
      </div>
      <div class="bot-content" v-if="showHistory">
        <custom-charts
          v-if="showHistory"
          :title="dataBtn"
          :dataList="dataList"
          :timer="timeValue"
        ></custom-charts>
      </div>

      <!-- <div class="pannel-data-name">
        设备采集数据
      </div>
      <div class="bot-data">
        <div class="data-content"></div>
        <div class="data-item" v-for="(value, key, index) in botData">
          <div class="item-key">{{ key }}</div>
          <div class="item-value">{{ value }}</div>
        </div>
      </div> -->
    </pannel-box>
    <div class="right_kanban common-bg" v-show="isShowUI">
      <div class="water">
        <water-env :waterArray="waterArray"></water-env>
      </div>
      <div class="air">
        <water-network
          :networkArray="networkArray"
          :septicArray="septicArray"
          :sumpArray="sumpArray"
        ></water-network>
      </div>
      <!-- <img src="@/assets/cut/env_right.png" alt="" /> -->
    </div>
  </div>
</template>

<script>
import {
  getEqpInfo,
  getEnvironmentHomePage,
  getEqpStatus,
} from "@/api/index.js";
import bus from "@/components/three-scene/Bus.js";
import AirQual from "./components/air-qual.vue";
import WaterEnv from "./components/water-env.vue";
import WaterNetwork from "./components/water-network.vue";
import AirQualIn from "./components/air-qualIn.vue";
export default {
  components: { AirQual, WaterEnv, WaterNetwork, AirQualIn },
  data() {
    return {
      isClickUI:false,
      timeValue: "day",
      dataList: { x: [], y: [] },
      dataBtn: "",
      historical: {},
      isShowUI: true,
      isShowDialog: false,
      isPull: false,
      isDisable: false,
      botData: {},
      headerData: {},
      numDeatil: "",
      airArrayIn: [
        { name: "二氧化碳", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "一氧化碳", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "甲醛(JQ)", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "VOC", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "PM2.5", num: "-", unit: "μg/m³", alarm: "0" },
      ],
      airArray: [
        { name: "PM2.5", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "PM10", num: "-", unit: "μg/m³", alarm: "0" },
        { name: "TSP", num: "-", unit: "μg/m³", alarm: "0" },
      ],
      airArrayBot: [
        { name: "风速", num: "-", unit: "m/s", alarm: "0" },
        { name: "风向", num: "-", unit: "", alarm: "0" },
        { name: "温度", num: "-", unit: "℃", alarm: "0" },
        { name: "湿度", num: "-", unit: "%RH", alarm: "0" },
        { name: "气压", num: "-", unit: "Kpa", alarm: "0" },
        { name: "噪音", num: "-", unit: "db", alarm: "0" },
      ],
      waterArray: [
        { name: "PH", num: "-", unit: "", alarm: "0" },
        { name: "电导率", num: "-", unit: "mS/cm", alarm: "0" },
        { name: "水温", num: "-", unit: "℃", alarm: "0" },
        { name: "浊度", num: "-", unit: "NTU", alarm: "0" },
        { name: "溶解度", num: "-", unit: "mg/L", alarm: "0" },
        { name: "COD", num: "-", unit: "mg/L", alarm: "0" },
        { name: "氨氮(NH3)", num: "-", unit: "mg/L", alarm: "0" },
        { name: "总磷", num: "-", unit: "mg/L", alarm: "0" },
        { name: "总氮", num: "-", unit: "mg/L", alarm: "0" },
      ],
      networkArray: [
        { name: "液位", num: "-", unit: "m", alarm: "0" },
        { name: "流量", num: "-", unit: "m³/s", alarm: "0" },
        { name: "流速", num: "-", unit: "m/s", alarm: "0" },
        { name: "PH值", num: "-", unit: "", alarm: "0" },
        { name: "温度", num: "-", unit: "℃", alarm: "0" },
        { name: "溶解液", num: "-", unit: "", alarm: "0" },
        { name: "浊度", num: "-", unit: "NTU", alarm: "0" },
        { name: "氨氮", num: "-", unit: "mg/L", alarm: "0" },
        { name: "电导率", num: "-", unit: "mS/cm", alarm: "0" },
      ],
      septicArray: [
        { name: "液位", num: "-", unit: "m", alarm: "0" },
        { name: "流量", num: "-", unit: "m³/s", alarm: "0" },
        { name: "流速", num: "-", unit: "m/s", alarm: "0" },
      ],
      sumpArray: [{ name: "液位", num: "-", unit: "m", alarm: "0" }],
      timer: null,
    };
  },

  created() {
    this.getOutStatus();
    this.getHomeData();
    this.timer = setInterval(() => {
      this.getOutStatus();
      this.getHomeData();
    }, 30*60*1000);
  },
  destroyed() {
    clearInterval(this.timer);
    this.timer = null;
  },
  watch: {
    dataBtn() {
      this.getChartData();
    },
  },
  computed: {
    showbotDetail() {
      if (this.botData) {
        return Object.keys(this.botData).length != 0;
      }
    },
    showHistory() {
      if (this.historical) {
        return Object.keys(this.historical).length != 0;
      } else {
        return false;
      }
    },
  },
  methods: {
    changeDay(value) {
      this.timeValue = value;
      this.getChartData();
      console.log(this.isShowDialog, "ss");
    },
    getChartData() {
      console.log(this.timeValue, "ss");
      if (this.timeValue == "day") {
        this.loadData(10, 13);
      } else if (this.timeValue == "month") {
        this.loadData(8, 11);
      } else {
        this.loadData(5, 8);
      }
    },
    chooseData(i) {
      this.dataBtn = i;
    },
    showbotData(val) {
      if (val) {
        if (val == "二氧化碳浓度") {
          return "CO2浓度";
        } else if (val == "一氧化碳浓度") {
          return "CO浓度";
        }
        return val;
      }
    },
    showItem(val) {
      if (val) {
        if (val.includes(".")) {
          return val.split(".")[0] + "." + val.split(".")[1].slice(0, 2);
        } else if (val == "暂无数据") {
          return "-";
        } else {
          return val;
        }
      }
      if (val == 0) {
        return "0";
      }
    },
    showUnit(val) {
      if (val.includes(".")) {
        return val.split(".")[1].slice(2);
      }
    },
    closeUI() {
      this.isShowUI = false;
    },
    loadData(first, end) {
      this.dataList = { x: [], y: [] };
      if (this.historical?.[this.timeValue]?.[this.dataBtn]) {
        this.historical?.[this.timeValue]?.[this.dataBtn].map((item, index) => {
          let [res] = Object.entries(item);
          this.dataList.x.push(res[0].slice(first, end));
          this.dataList.y.push(res[1]);
        });
      }
    },

    async getOutStatus() {
      let { data: res } = await getEqpStatus({
        buildNo: "07",
        floor: "A01",
        module: "HJ",
      });
      bus.emit("getOutStatus", res);
    },
    uiClick(e) {
      // console.log(e.path.includes(this.$refs.waterPannel.$el),"1111");
      // if (e.path.includes(this.$refs.waterPannel.$el)) {
      //   console.log("1");
      //   this.isClickUI=true
      // }else{
      //   console.log("2");
      //   this.isClickUI=false
      // }
    },
    closeDialog() {
      this.dataBtn = null;
      this.timeValue = "day";
      this.isShowDialog = false;
    },
    busCloseDialog() {
        this.closeDialog()
    },
    returnScence() {
      bus.emit("back");
      if (this.isShowDialog) {
        this.closeDialog();
      }
      if (!this.isShowUI) {
        this.isShowUI = true;
      }
      bus.emit("pipelineIsShow");
    },
    async dialogShow(eqpCode) {
      this.botData = null;
      let resList = [];
      if (eqpCode.includes("、")) {
        let arr = eqpCode.split("-");
        for (let index in arr) {
          if (arr[index].includes("、")) {
            let resArr = arr[index].split("、");
            resArr.map((item) => {
              arr[index] = item;
              resList.push(JSON.parse(JSON.stringify(arr.join("-"))));
            });
          }
        }
      } else {
        resList.push(eqpCode);
      }
      let statusArray = [];
      let resArr = [];
      let resLength = resList.length;
      for (let index = 0; index < resLength; index++) {
        resArr.push(getEqpInfo({ eqpCode: resList[index] }));
      }
      Promise.all(resArr)
        .then((res) => {
          for (let index = 0; index < res.length; index++) {
            let {
              data: { baseData, collectionValue, historical },
            } = res[index];

            if (baseData && collectionValue && historical) {
              this.botData = {
                ...collectionValue.data,
                ...this.botData,
              };
              this.historical = {
                day: {
                  ...historical.day,
                  ...this.historical.day,
                },
                month: {
                  ...historical.month,
                  ...this.historical.month,
                },
                year: {
                  ...historical.year,
                  ...this.historical.year,
                },
              };
              this.headerData = baseData;
              this.headerData["eqpName"] = collectionValue.eqpName;
            } else if (collectionValue && baseData) {
              // 环境监测地下数据
              this.headerData["eqpName"] = collectionValue.eqpName;
              this.botData = {
                ...collectionValue.data,
                ...this.botData,
              };
              this.headerData = baseData;
            }
            statusArray.push(baseData.status);
            if (index == res.length - 1) {
              this.dataBtn = Object.keys(this.botData)[0];
              this.isShowDialog = true;
            }
          }
        })
        .catch((e) => {
          console.log(e, "ee");
        });

      if (statusArray.includes(1)) {
        this.headerData["status"] = 1;
      }
      if (statusArray.includes(0)) {
        this.headerData["status"] = 0;
      }
      if (statusArray.includes(2)) {
        this.headerData["status"] = 2;
      }
    },
    getWaterData(eqpCode) {
      console.log(123);
      getEqpInfo({ eqpCode }).then((res) => {
        let {
          data: { collectionValue, baseData, historical },
        } = res;
      console.log(234);

        // this.headerData.status=baseData.status;
        // console.log(this.headerData.status,baseData.status,'base');
        this.headerData = baseData;
        this.botData = collectionValue.data;
        this.dataBtn = Object.keys(this.botData)[0];
        this.historical = historical;
        this.loadData(10, 13);
        this.isShowDialog = true;
      });
    },
    setUnit(key) {
      this[key].map((item) => {
        if (item.num == "-") {
          item.unit = "";
        }
      });
    },
    async getHomeData() {
      let { data: res } = await getEnvironmentHomePage();
      // //室内
      this.airArrayIn[0].num = res.indoorEnvironment.CO2.value;
      this.airArrayIn[0].alarm = res.indoorEnvironment.CO2.alarm;
      this.airArrayIn[1].num = res.indoorEnvironment.CO.value;
      this.airArrayIn[1].alarm = res.indoorEnvironment.CO.alarm;
      this.airArrayIn[2].num = res.indoorEnvironment.JQ.value;
      this.airArrayIn[2].alarm = res.indoorEnvironment.JQ.alarm;
      this.airArrayIn[3].num = res.indoorEnvironment.VOC.value;
      this.airArrayIn[3].alarm = res.indoorEnvironment.VOC.alarm;
      this.airArrayIn[4].num = res.indoorEnvironment["PM25"]?.value ?? "-";
      this.airArrayIn[4].alarm = res.indoorEnvironment["PM25"]?.alarm ?? "0";

      // //室外
      // console.log(res.outdoorEnvironment["PM2.5"]?.value);
      this.airArray[0].num = res.outdoorEnvironment["PM2.5"]?.value?.slice(
        0,
        -5
      );
      this.airArray[1].num = res.outdoorEnvironment.PM10?.value?.slice(0, -5);
      this.airArray[2].num = res.outdoorEnvironment.TSP?.value?.slice(0, -5);

      this.airArrayBot[0].num = res.outdoorEnvironment.windSpeed?.value?.slice(
        0,
        -3
      );
      this.airArrayBot[1].num = res.outdoorEnvironment.windDirection?.value;
      this.airArrayBot[2].num = res.outdoorEnvironment.temperature?.value?.slice(
        0,
        -2
      );
      this.airArrayBot[3].num = res.outdoorEnvironment.humidity?.value?.slice(
        0,
        -3
      );
      this.airArrayBot[4].num = res.outdoorEnvironment.airPressure?.value?.slice(
        0,
        -3
      );
      this.airArrayBot[5].num = res.outdoorEnvironment.noise?.value?.slice(
        0,
        -2
      );

      // //水环境
      this.waterArray[1].num = res.waterEnvironment.conductivity.value;
      this.waterArray[1].alarm = res.waterEnvironment.conductivity.alarm;
      this.waterArray[2].num = res.waterEnvironment.waterTemperature.value;
      this.waterArray[2].alarm = res.waterEnvironment.waterTemperature.alarm;
      this.waterArray[3].num = res.waterEnvironment.turbidity.value;
      this.waterArray[3].alarm = res.waterEnvironment.turbidity.alarm;
      this.waterArray[4].num = res.waterEnvironment.dissolution.value;
      this.waterArray[4].alarm = res.waterEnvironment.dissolution.alarm;

      //排水官网
      // this.networkArray[]
      this.networkArray[0].num = res.pipeNetwork.Level.value;
      this.networkArray[0].alarm = res.pipeNetwork.Level.alarm;
      this.septicArray[0].num = res.septicTank.Level.value;
      this.septicArray[0].alarm = res.septicTank.Level.alarm;
      this.setUnit("airArrayIn");
      this.setUnit("airArray");
      this.setUnit("airArrayBot");
      this.setUnit("waterArray");
      this.setUnit("networkArray");
      this.setUnit("septicArray");
      this.setUnit("sumpArray");
    },
  },
  mounted() {
    this.$store.state.threeEvent.intoEnviron = true;
    bus.emit("openFloorLabel", true);
    bus.emit("showFloorPoint", "室内空气", true);
    bus.emit("emp", true);
    bus.emit("createDialogs", "waterPannelThree");
    bus.on("empNumber", this.getWaterData);
    bus.on("dialogNumber", this.dialogShow);
    bus.on("dialogClose", this.busCloseDialog);
    bus.on("closeHJUI", this.closeUI);
  },
};
</script>
